import utils from '@/js/utils';
import MENU_DATA_OPS from '@/configs/menus/dataops.menu';
export default [{
  path: '/dataops/overview',
  name: 'overviewdataops',
  component: function component() {
    return import(/* webpackChunkName: "apps-dataops" */'@/apps/dataops/pages/OverviewPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('overview', MENU_DATA_OPS)
  }
}, {
  path: '/dataops/orchestration',
  name: 'orchestration',
  component: function component() {
    return import(/* webpackChunkName: "apps-dataops" */'@/apps/dataops/modules/orchestration/Orchestrator.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('orchestration', MENU_DATA_OPS)
  }
}, {
  path: '/dataops/import_script',
  name: 'import_script',
  component: function component() {
    return import(/* webpackChunkName: "apps-dataops" */'@/apps/dataops/modules/orchestration/ImportScript.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('orchestration', MENU_DATA_OPS)
  }
}, {
  path: '/dataops/executions_history',
  name: 'executions_history',
  component: function component() {
    return import(/* webpackChunkName: "apps-dataops" */'@/apps/dataops/modules/orchestration/Executions.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('orchestration', MENU_DATA_OPS)
  }
}];